<template>
  <div class="nav">

    <router-link class='list' tag='li' to="/console/calendar">课程日历</router-link>
<!--    <router-link class='list' tag='li' to="/console/confirm/class">试听确认</router-link>-->
    <router-link class='list' tag='li' to="/console/lesson">课程列表</router-link>
    <router-link class='list' tag='li' to="/console/homework">作业管理</router-link>
    <!--    <router-link class='list' tag='li' to="/console/order">订单管理</router-link>-->
    <router-link class='list' tag='li' to="/console/statistic">统计结算</router-link>
    <router-link class='list' tag='li' to="/console/pupils">自有生源</router-link>
    <router-link class='list' tag='li' to="/console/live">直播测试</router-link>
<!--    <router-link class='list' tag='li' to="/console/school">网校后台</router-link>-->
    <router-link class='list' tag='li' to="/console/myProfile">我的资料</router-link>
    <router-link class='list' tag='li' to="/console/files">文件管理</router-link>
    <!--<router-link class='list' tag='li' to="/console/activity">{{$t("m.sidenav_yxhd")}}</router-link>-->
    <!--<router-link class='list' tag='li' to="/account/personal">{{$t("m.sidenav_grzx")}}</router-link>-->
    <!--<router-link class='list' tag='li' to="/account/personal">消息</router-link>-->
  </div>
</template>

<script type="text/ecmascript-6">
  export default {

  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .nav
    position fixed
    top: 40px
    left: 0
    bottom: 0
    width: 160px
    background #224466
    .list
      display:block;
      height: 55px
      line-height: 55px
      font-size: 15px
      color: #ffffff
      text-indent: 30px
      cursor: pointer
      &:hover
        background: #336699
      &.active{
        background: #369
      }
    .router-link-active
      background: #336699


</style>



// WEBPACK FOOTER //
// src/components/sidenav/SideNav.vue